module.exports = "<img [src]=\"getProductImg()\">\r\n<span class=\"kt-font-bold\">\r\n  {{productName}}</span>"